import biographiesAndMemories from '../../images/category-icons/biographies-and-memories-icon.svg';
import business from '../../images/category-icons/business-icon.svg';
import communication from '../../images/category-icons/communication-icon.svg';
import economics from '../../images/category-icons/economics-icon.svg';
import education from '../../images/category-icons/education-icon.svg';
import entrepreneurship from '../../images/category-icons/entrepreneurship-icon.svg';
import fiction from '../../images/category-icons/fiction-icon.svg';
import fitness from '../../images/category-icons/fitness-icon.svg';
import general from '../../images/category-icons/general-icon.svg';
import health from '../../images/category-icons/health-icon.svg';
import history from '../../images/category-icons/history-icon.svg';
import managementAndLeadership from '../../images/category-icons/management-and-leadership-icon.svg';
import personalDevelopment from '../../images/category-icons/personal-development-icon.svg';
import philosophy from '../../images/category-icons/philosophy-icon.svg';
import politics from '../../images/category-icons/political-icon.svg';
import productivity from '../../images/category-icons/productivity-icon.svg';
import psychology from '../../images/category-icons/psychology-icon.svg';
import science from '../../images/category-icons/science-icon.svg';
import selfHelp from '../../images/category-icons/self-help-icon.svg';
import sociology from '../../images/category-icons/sociology-icon.svg';
import technology from '../../images/category-icons/technology-icon.svg';

export default {
  biographiesAndMemories,
  business,
  communication,
  economics,
  education,
  entrepreneurship,
  fiction,
  fitness,
  general,
  health,
  history,
  managementAndLeadership,
  personalDevelopment,
  philosophy,
  politics,
  productivity,
  psychology,
  science,
  selfHelp,
  sociology,
  technology,
};
